import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'antd';
import { LocalizationContext } from '../../../hoc/Localization';
import Search from '../../CourseSearch';
import styles from './styles.less';

const LandingHeader = ({ category }) => {
  const { translate } = React.useContext(LocalizationContext);
  const { imageUrl } = category;

  return (
    <div className={styles.container}>
      <Row className={styles.row} type="flex" gutter={20}>
        <Col className={styles.title} xs={24} lg={12}>
          <h1>{translate(category, 'title')}</h1>
          <span className={styles.contentText}>{translate(category, 'content')}</span>
          <Search category={category.label} type="landing" name="search_landing_page" />
        </Col>
        <Col
          style={{
            position: 'static',
          }}
          className={styles.imageCol}
          xs={24}
          lg={12}
        >
          <div
            style={{
              backgroundImage: `url(${imageUrl})`,
            }}
            className={styles.cover}
          />
        </Col>
      </Row>
    </div>
  );
};

LandingHeader.propTypes = {
  category: PropTypes.string.isRequired,
};

export default LandingHeader;
